import React, {useContext, useState, useEffect} from 'react'
import Head from '../components/antifraud/Head'
import Back from '../components/donate/Back'
import Content from '../components/antifraud/Content'
import ProgressBox from '../components/antifraud/ProgressBox'
import styled from 'styled-components';
import {useWeb3React as useWeb3ReactCore} from '@web3-react/core'
import {InjectedConnector} from '@web3-react/injected-connector';
import BaseBtn from '../components/common/styled/BaseBtn'
import SuccessModel from '../components/model/SuccessModel'
import Loader from "../components/common/Loading";
import {mainContext} from "../reducer";
import {TRIAS_SELECTED_WEB3_CONTEXT,THIS_CHAIN_ID} from "../const";
import SupportSubjectModel from '../components/antifraud/SupportSubjectModel'
import {useAntiFraudStakingExist} from '../hooks'
import InputAmountModel from '../components/antifraud/InputAmountModel'

const ContStyle = styled.div`
  width: 1080px;
  margin: auto;
  font-size: 20px;
  .support-btn {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 70px;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
    .support-btn {
      justify-content: center;
      margin-top: 40px;
    }
  }
`;

const W66 = styled.div`
  width: 66.6%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

/**
 * 反诈骗计划
 */
export default function AntiFraud() {
  const {active, activate, account, chainId} = useWeb3ReactCore()
  const isStaked = useAntiFraudStakingExist();

  const {transactions} = useContext(mainContext).state
  const approving = transactions.find((item) => {
    return (
        item.approve &&
        item.approve.status === 0 &&
        item.approve.account === account
    )
  })

  const staking = transactions.find((item) => {
    return (
        item.stake &&
        account === item.stake.account &&
        item.stake.status === 0
    )
  })

  const [supportSubjectModel, setSupportSubjectModel] = useState(false);
  const toggleSupportSubjectModel = ()=> {
    setSupportSubjectModel(!supportSubjectModel);
  }

  const [showMeta, setshowMeta] = useState(false)

  const toSupportModel = ()=>{
    if (!window.ethereum) {
      setshowMeta(true)
      return ;
    }

    setInputModel(true);
    if (active) {
      if(chainId !== THIS_CHAIN_ID && THIS_CHAIN_ID===56){
        if (window.ethereum) {
          window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: `0x${(56).toString(16)}`,
                chainName: 'Binance Smart Chain',
                nativeCurrency: {
                  name: 'BNB',
                  symbol: 'BNB',
                  decimals: 18
                },
                rpcUrls: ['https://bsc-dataseed3.binance.org',
                  'https://bsc-dataseed1.binance.org',
                  'https://bsc-dataseed2.binance.org'],
                blockExplorerUrls: ['https://bscscan.com']
              }
            ]
          })
        }

      }else {
        toggleSupportSubjectModel()
      }
    } else {
      const injected = new InjectedConnector({
        supportedChainIds: [1, 3, 4, 5, 42, 66, 128, 137],
      });
      activate(injected)
          .then(() => {
            window && window.localStorage.setItem(
                TRIAS_SELECTED_WEB3_CONTEXT,
                'MetaMask'
            );
            console.log('connected')
          })
          .catch((e) => {
            console.log('connect error', e)
          });
    }
  };

  const [stakeSuccessModel, setStakeSuccessModel] = useState(false);
  const toggleStakeSuccessModel = ()=>{
    setStakeSuccessModel(!stakeSuccessModel);
  };

  const [inputmodel, setInputModel] = useState(false)
  const toggleInputModel = ()=>{
    setInputModel(!inputmodel);
  };

  const [informationModel, setInformationModel] = useState(false);
  useEffect(() => {
    isStaked && setInformationModel(true);
  }, [isStaked])

  return (
    <>
      <Head></Head>
      <ContStyle>
        <W66>
          <Back></Back>
        </W66>
        <Content toSupportModel={toggleSupportSubjectModel}>
          <div className="support-btn">
            <BaseBtn disabled={isStaked || approving || staking} width="200px" heigth="52px"
              onClick={toggleSupportSubjectModel}
              >
              {isStaked ? 'Staked' : active ? (THIS_CHAIN_ID === 56 && chainId !== THIS_CHAIN_ID) ? 'Switch to BSC' : approving ? 'Approve' : staking ? 'Granting' : 'Stake TRIAS' : 'Connect'}
              {(approving || staking) && <Loader />}
            </BaseBtn>
            <ProgressBox></ProgressBox>
          </div>
        </Content>

        <SupportSubjectModel
          show={supportSubjectModel}
          onHide={toggleSupportSubjectModel}
          toSupport={toSupportModel}
          ></SupportSubjectModel>
        
        <SuccessModel key='3' show={stakeSuccessModel} onHide={toggleStakeSuccessModel}>
          <div>Transaction Submitted.</div>
          <div><a target="_blank" rel="noreferrer" href="https://forms.gle/jYU6pCvjGAwAgLw86">Now please fill out the information form</a></div>
        </SuccessModel>

        <SuccessModel key='4' show={informationModel} onHide={()=>{
          setInformationModel(false)
        }}>
          <div><a target="_blank" rel="noreferrer" href="https://forms.gle/jYU6pCvjGAwAgLw86">You should submit the information form if you don’t have one.</a></div>
        </SuccessModel>
      </ContStyle>

      <InputAmountModel
        show={inputmodel}
        onSuccess={toggleStakeSuccessModel}
        onHide={toggleInputModel}
      ></InputAmountModel>

      <SuccessModel
        show={showMeta}
        onHide={()=>{
          setshowMeta(false)
        }}
      >Please install a Metamask extension on the browser(PC) and link it first.</SuccessModel>
    </>
  )
}
